var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "antialiased", style: _vm.font },
    [
      _vm._t("default"),
      _vm._v(" "),
      _vm._l(_vm.fonts, function(font, index) {
        return _c("font", {
          key: index,
          attrs: { src: font.src, name: font.name, weight: font.weight }
        })
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }